<template minapp='mpx' xlang='wxml'>
  <view class='checkbox-icon__container custom-class' wx:style="{{styles}}" bindtap="handleClick">
    <text wx:if="{{disabled && !checked}}" class="checkbox-icon checkbox-icon__disabled custom-disabled"></text>
    <view wx:elif="{{disabled && checked}}" class="checkbox-icon checkbox-icon__disabled-checked custom-disabled-checked">
      <es-icon name="check-filled" size="{{size - 6}}" color="#fff"/>
    </view>
    <view wx:elif="{{!disabled && checked}}" class="checkbox-icon checkbox-icon__checked custom-checked">
      <es-icon name="check-filled" size="{{size - 6}}" color="#fff"/>
    </view>
    <text wx:elif="{{!disabled && !checked}}" class="checkbox-icon checkbox-icon__normal custom-normal"></text>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    classes: ['custom-normal', 'custom-checked', 'custom-disabled', 'custom-disabled-checked'],
    componentName: 'CheckboxIcon',
    props: {
      size: {
        type: Number,
        value: 18
      },
      disabled: Boolean,
      checked: Boolean
    },
    computed: {
      styles() {
        return {
          width: this.size + 'px',
          height: this.size + 'px'
        }
      }
    },
    methods: {
      handleClick(e) {
        // if (!this.disabled) {
        this.$trigger('checkbox-select', e);
        // }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .checkbox-icon__container
    display inline-block
    .checkbox-icon
      box-sizing border-box
      display flex
      width 100%
      height 100%
      align-items center
      justify-content center
      border-radius 6px
    .checkbox-icon__disabled
      background #eeeeee
      border 1px solid #D4D3D3
    .checkbox-icon__disabled-checked
      background #eeeeee
      border 1px solid #D4D3D3
    .checkbox-icon__checked
      background #FF6400
    .checkbox-icon__normal
      border 1px solid #D4D3D3
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
    }
  }
</script>

